import axios from "axios"
import { Token } from "../components/urlParams";
import { REACT_APP_USER_API_URL } from "../envVariables";



export const getUserDetails = async () => {
    try {
        const responce = await axios.get(`${REACT_APP_USER_API_URL}user/get-user`, {
            headers: {
                'Authorization': `AccessToken=${Token}`,
                'Content-Type': 'application/json',
            }
        })
        return responce.data.data;
    } catch (err) {
        console.log('getting error get user', err)
    }
}